const ROOT_PATH = '/';
export const LOGIN = {
  PATH: ROOT_PATH,
  toPath: () => ROOT_PATH,
};
